module.exports = __webpack_public_path__ + "img/IcnInfo.528af389.png";